import { Theme } from "@mui/material";

export const GetPriorityColor = (theme: Theme) => ({
    high: theme.palette.error.light,
    medium: theme.palette.warning.main,
    low: theme.palette.info.light,
    none: theme.palette.grey[500]
});

export const getStatusColor = (theme: Theme) => ({
    completed: theme.palette.success.main,
    upcoming: theme.palette.secondary.main,
    overdue: theme.palette.error.main
});

export type PriorityColor = keyof ReturnType<typeof GetPriorityColor>;
export type StatusColor = keyof ReturnType<typeof getStatusColor>; 